import React, { useState } from "react";
import SignInImage from "./../assets/images/sign-in.png";
import { NavBar } from "../components/nav-bar";
import { Footer } from "../components/footer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { UserService } from "../app/service/user.service";
import { useAppContext } from "../context/AppContext";

export const ForgotPassword = () => {
  const { showLoader, hideLoader, handleLogin }: any = useAppContext();
  const [signInData, setSignInData] = useState<any>({
    email: "",
  });
  const navigation = useNavigate();

  const handleInput = (e: any) => {
    const { name, value } = e.target;
    setSignInData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e:any) => {
    e.preventDefault();
    let payload = {
      email: signInData?.email,
    };
    showLoader();
     UserService.forPassword(payload)
      .then(async (res: any) => {
        if (res?.status === "Success") {
          toast.success(res.message);
          hideLoader();
        } else {
          toast.error(res.message);
          hideLoader();
        }
      })
      .catch((err: any) => {
        console.log(err);
        hideLoader();
      });
  };

  return (
    <div className="container-fluid scroll-bar-width-none primary-bg text-white pt-5">
      <div className="row">
        <div className="col-md-12">
          <NavBar activeMenu={"home"} />
        </div>
        <div className="col-md-12 px-3 mx-md-0">
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-10 col-md-11 mx-auto pt-5">
                  <div className="fs-2 fw-bold my-3 text-start">
                    Forget
                    <span className="primary-color"> Password</span>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label d-flex justify-content-start">
                        Email ID
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control custom-input bg-transparent border-0 border-bottom rounded-0 text-white"
                        value={signInData.email}
                        onChange={handleInput}
                        required
                      />
                    </div>
                    <div className="my-4">
                      <button
                        type="submit"
                        className="bg-white px-5 py-2 w-100 secondary-btn"
                      >
                        Send
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-6 px-0 d-none d-md-block pt-4">
              <div className="d-flex justify-content-end">
                <img src={SignInImage} className="w-100" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 border-top border-bottom border-light mt-3 pt-4 text-white">
          <Footer />
        </div>
      </div>
    </div>
  );
};
